<template>
    <!-- 对话框 -->
    <el-dialog title="评价内容" :visible.sync="show" :before-close="closeDialog" style="width:60%; margin: 0 auto;">

        <!-- 基本信息表单 -->
        <div class="form-box">
            {{data.remarks}}

            <div style="display: flex;justify-content: center">
                <el-button type="danger" @click="del">删除评价</el-button>
                <el-button @click="closeDialog">关闭</el-button>
            </div>

        </div>

    </el-dialog>
</template>

<script>
    var _this;

    export default {
        props: {
            'isShow': Boolean,
            'data': ''
        },
        watch: {

            isShow(newData, oldData) {

                _this.show = true;
                _this.submit_data.order_code = _this.data.order_code;
                _this.submit_data.driver_code = _this.data.driver_code;
                _this.submit_data.star_point = _this.data.star_point;


                _this.walletInit();

            },

        },
        data() {
            return {

                show: false,

                // 表单提交数据
                submit_data: {
                    order_code: '',
                    driver_code: '',
                    star_point: ''
                },


            };
        },
        created() {
            _this = this;

        },
        methods: {
            // 获取钱包信息
            del(){
                _this.$post(
                    "/driver/delOrderAssess",
                    _this.submit_data
                )
                    .then(res => {

                        _this.$emit('onSubmit')
                        _this.closeDialog()
                        console.log(res.data);


                    }).catch((err) => {

                })
            },
            // 关闭方法
            closeDialog() {

                _this.show = false;


                    _this.submit_data={
                        order_code: '',
                        driver_code: '',
                        star_point: ''
                    };
                }






        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
    }
</style>
